import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Engineering from "./pages/Engineering";
import Fabrication from "./pages/Fabrication";
import ITServices from "./pages/ITServices";
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      <Navbar />
      <div style={{ padding: "20px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/engineering" element={<Engineering />} />
          <Route path="/fabrication" element={<Fabrication />} />
          <Route path="/it-services" element={<ITServices />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
